import { store } from "@/stores/global.js";
import { set, get } from "@/utils/localstorage";

let sPATH = `auth/g/authenticate/dataTool/v0`;

async function buildURL(toolName) {
    return `https://${store.env}.quotemedia.com/${sPATH}/${store.wmid || 101894}/${await generateSHA256(toolName)}`;
}

async function generateSHA256(string) {
    const utf8 = new TextEncoder().encode(string);
    const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(bytes => bytes.toString(16).padStart(2, "0")).join("");
    return hashHex;
}

function setToolStorage(name, value) {
    set(name, value, 29);
}

function getToolStorage(name) {
    return get(name);
}

function generateToolStoragePrefix(toolName) {
    return `${store.env}_${store.wmid}_QMODII_${toolName}`;
}

export async function getToolToken(toolName) {
    const toolPrefix = generateToolStoragePrefix(toolName);
    const toolToken = getToolStorage(toolPrefix);

    if (toolToken) {
        return new Promise(resolve => {
            resolve(toolToken);
        });
    }
    let result = await fetch(await buildURL(toolName), {
        method: "post",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    result = await result.json();

    setToolStorage(toolPrefix, result.token);
    return result.token;
}

export async function getSID() {
    const path = `auth/v0/session/${store.wmid}`;

    const resp = await fetch(`https://${store.env}.quotemedia.com/${path}`, {
        credentials: "include",
    });
    const { sid } = await resp.json();

    store.sid = sid;
    return sid;
}
